import React from 'react';
import { EMBED_ERROR, toDrivePreviewUrl } from '../utils/drive';
interface AudioMasterProps {
  label: string;
  driveUrl: string;
}

/**
 * The audio review player.
 *
 * A Google Drive audio link is embedded directly — Drive's own preview UI
 * supplies playback, scrubbing and volume, so nothing here needs to fake
 * transport controls or track a runtime that was never real. No link, or a
 * link Drive can't embed, is stated plainly rather than shown as a working
 * player.
 *
 * ON THE HEIGHT, because it has already been wrong once (18 Sep 2026):
 * the frame was 80px and Drive's waveform player is taller than that, so it
 * was clipped at BOTH ends — the play button cut off at the top, the
 * waveform cut off at the bottom. Drive centres its player inside whatever
 * viewport it is given, so too short crops symmetrically rather than simply
 * hiding the bottom, which is why it read as broken rather than cramped.
 *
 * The height has to be fixed and generous: the iframe is cross-origin, so
 * its content height cannot be measured, and Drive renders two different
 * players — a full waveform for some files, a compact transport bar for
 * others. 176px clears the taller one with room to spare; the compact one
 * simply sits centred in a little more dark space, which reads as
 * deliberate rather than broken.
 */
export function AudioMaster({
  label,
  driveUrl
}: AudioMasterProps) {
  const embedUrl = toDrivePreviewUrl(driveUrl);
  const linkProvided = Boolean(driveUrl.trim());
  /** Only the link itself can be judged — Drive is cross-origin and opaque. */
  const showError = linkProvided && !embedUrl;
  return <div className="border-t border-rule py-6" data-id="element-21" data-mp="1epwiuzp9tkwl">
      <p className="font-display text-lg leading-none" data-id="element-22" data-mp="1jn6dquvfiort">{label}</p>

      {embedUrl ? <div className="relative mt-5 h-44 w-full overflow-hidden border border-rule bg-paperDeep" data-id="element-23" data-mp="392cuyh4qzt9d">
          <iframe title={label} src={embedUrl} allow="autoplay" className="h-full w-full border-0" data-id="element-24" data-mp="3e1fnj23jk70g" />
        </div> : showError ? <div className="mt-5 border border-rule bg-paperDeep px-5 py-4" data-id="element-25" data-mp="37l77qeuuaqfm">
          <p className="label-sm m-0 text-mute" data-id="element-26" data-mp="37jw5ijh1lqqm">{EMBED_ERROR}</p>
          <a href={driveUrl} target="_blank" rel="noreferrer" className="label mt-3 inline-block text-graphite underline underline-offset-4 transition-colors duration-150 ease-out hover:text-ink" data-id="element-27" data-mp="32n5lxm614d0g">
            Open in Google Drive
          </a>
        </div> : <p className="label-sm mt-5 text-mute" data-id="element-28" data-mp="3qcgrdgybqvkx">Awaiting Drive link</p>}
    </div>;
}